<template>
  <div class="progress">
    <div
      class="progress-bar progress-bar-striped"
      role="progressbar"
      :aria-valuenow="value"
      :aria-valuemin="min"
      :aria-valuemax="max"
      :style="styles"
      :class="barClasses"
    ></div>
  </div>
</template>

<script lang="ts">
  import Vue from "vue"
  import { Hash } from '../interfaces/hashInterfaces'

  export default Vue.extend({
    props: {
      min: {
        type: Number,
        default: 0,
      },
      max: {
        type: Number,
        default: 100,
      },
      value: {
        type: Number,
        default: null,
      },
      barClasses: {
        type: String,
        default: null,
      },
    },
    computed: {
      width (): number {
        return (this.value - this.min) / (this.max - this.min) * 100
      },
      styles (): Hash {
        return {
          width: this.width + '%',
        }
      },
    },
  })
</script>
